/* Copyright 2022- Martin Kufner */
import {QbElement} from "./qb-element.js"
import { DateTime } from "@node/luxon";
import flatpickr from "@node/flatpickr";
import "@node/flatpickr/dist/flatpickr.min.css";

export class QbTime extends QbElement {
    #date
    #duration
    #strftime
    static shadow = {mode: 'closed', sheets: ["qb-elements"]}

    static observedAttributes = ['datetime', 'format', 'timezone', 'lang'];
    static template = '<slot></slot>';

    #dates = {}
    // constructor() {
    //     super();
    //     const slot = SLOT({beforeend: this.contentRoot});
    // }

    handleEvent(evt) {
        if(!this.firstElementChild) return;
        switch(evt.type) {
            case "click":
                this.flatpickr;
                return;
            case "change":
                this.date = this.firstElementChild.value;
                return;
        }
    }

    // $open(value) {
    //     if(!this.name) return;
    //     if(value === null) {
    //     }
    //     else this.#flatpickr.open();
    // }

    set dates(value) {
        // if(this.#flatpickr) this.#flatpickr.redraw();
    }
    get dateInZone() {
        const date = this.date || new Date();
        return date.toZoneISOString().slice(0,16);
    }

    get flatpickr() {
        const input_datetime = this.firstElementChild,
        input_timezone = this.lastElementChild;
        if(this.contentRoot.querySelector('input[type="text"]')) return;
        const value = this.dateInZone;
        input_datetime.value = value;
        const flatpickrinput = INPUT({type: "text", beforeend: this.contentRoot, value});
        const fp = flatpickr(flatpickrinput, {
            // inline: true,
            clickOpens: false, // we control opening
            allowInput: false,
            enableTime: true,
            time_24hr: true,
            animate: false,
            minuteIncrement: 15,
            // defaultDate: this.date,
            dateFormat: "Y-m-d\\TH:i",
            appendTo: this,
            // wrap: true,
            onClose: (selectedDates, dateStr, instance) => {
                if (selectedDates.length === 0) return;
                const zone = instance.timezoneNode.value;
                const dateTime = DateTime.fromISO(dateStr, { zone });
                const date = dateTime.toJSDate();
                date.zone = zone;
                this.date = date;

                // this.setAttribute("datetime", new Date(dateStr).toISOString());


                // slot.remove();
                instance.destroy();
                flatpickrinput.remove();
            },
            onChange: (selectedDates, dateStr, instance) => {

                    //
                    // qb_time.timezone = instance.timezone.value;
                    // instance.setDate(qb_time.dateInZone,true);
            },
            onDayCreate: (dObj, dStr, fp, dayElem) => {
                const dateStr = dayElem.dateObj.toISOString().substring(0,16);
                const dayStr = dateStr.split("T")[0];
                for(const [k,v] of Object.entries(this.#dates)) {
                    if(k === dateStr) dayElem.dataset.availability = v ? "booked" : "blocked";
                    else if(k.startsWith(dayStr)) dayElem.dataset.availability = v ? "other" : "blocked";
                    else if(this.#matchesCron(dayElem.dateObj, k)) dayElem.dataset.availability = v ? "available" : "blocked";
                    else continue;
                    break;
                }
            },
            onReady: function(selectedDates, dateStr, instance) {
                if(!input_timezone) return;
                instance.timezoneNode = SELECT({class: "timezone", beforeend: instance.calendarContainer});
                instance.timezoneNode.innerHTML = input_timezone.list.innerHTML;
                instance.timezoneNode.value = input_timezone.value;
            }
        });
        fp.open();
        fp.setDate(this.date, false);
    }

    #matchesCron(day, key) {
        // day = Date object
        // key examples:
        // "2026W*D7" -> every Sunday in 2026
        // "*W2,4,6D1,2,3" -> weeks 2,4,6, Mon/Tue/Wed

        // extract year if present
        let yearMatch = key.match(/^(\d{4})/);
        if (yearMatch && parseInt(yearMatch[1]) !== day.getFullYear()) return false;

        // extract weeks
        let weekMatch = key.match(/W([0-9,*-]+)/);
        let weekNumbers = [];
        if (weekMatch) {
            if (weekMatch[1] === "*") {
                weekNumbers = null; // match all weeks
            } else {
                weekNumbers = weekMatch[1].split(",").map(n => parseInt(n));
            }
        }

        // extract weekdays
        let dayMatch = key.match(/D([0-9,*-]+)/);
        let dayNumbers = [];
        if (dayMatch) {
            if (dayMatch[1] === "*") {
                dayNumbers = null; // match all days
            } else {
                dayNumbers = dayMatch[1].split(",").map(n => parseInt(n));
            }
        }

        // compute ISO week number
        const jan1 = new Date(day.getFullYear(),0,1);
        const days = Math.floor((day - jan1) / (24*60*60*1000));
        const weekNumber = Math.ceil((days + jan1.getDay()+1)/7);

        const weekday = day.getDay() || 7; // JS Sunday=0 -> 7

        if (weekNumbers && !weekNumbers.includes(weekNumber)) return false;
        if (dayNumbers && !dayNumbers.includes(weekday)) return false;

        return true;
    }


    get timezone() {
        return this.getAttribute("timezone") || "UTC"
    }

    set timezone(value) {
        if(!value) this.removeAttribute("timezone");
        else this.setAttribute("timezone", value);
    }

    $timezone(value) {
        if(this.#date && this.#date.zone !== value) {
            this.#date.zone = value;
            this.date = this.#date;
        }
    }

    $lang(value) {
        if(this.#date && this.#date.lang !== value) {
            this.#date.lang = value;
            this.date = this.#date;
        }
    }

    connectedCallback() {
        const input = this.querySelector("input");
        if(input) {
            this.addEventListener("click", this);
        }
        const select = this.querySelector("select");
        if(select) input.addEventListener("change", this);
        if(this.#date) {
            this.#date.lang = this.closest("[lang]")?.lang || "en";
            this.date = this.#date;
        }
    }

    now(...args) {
        return new Date(...args);
    }

    msecs(...args) {
        return this.now(...args) * 1;
    }

    parse(value) {
        return Date.parse(value);
    }

    get clear() {
        this.removeAttribute("datetime");
        this.removeAttribute("duration");
    }

    get #render_clear() {
        for(const node of this.nodes) {
            for(const n of node.children) {
                if(n.nodeName !== "I") return n.remove();
                delete n.dataset.value;
                n.textContent = "";
            }
        }
    }

    #render(node) {
        const {format, type, flag, pad} = node.dataset;
        if(type === "duration") { return console.log(node); }
        const value = node.method();
        if(/^\d+$/.test(value)) node.dataset.value = value;
        else if(!value) node.dataset.value = "";
        else node.dataset.value = value;

        if(isNaN(value)) {
            const n = node.firstElementChild;
            n.dataset.value = n.textContent = value;
            return;
        }
        const formatted = [...value.toString()];
        for(const n of [...node.children].reverse()) {
            const value = formatted.pop();
            n.dataset.value = value || pad || "";
            n.textContent = n.dataset.value.replace(/\s/g, "\u00A0");
        }
        formatted.forEach(value => cT.B({afterbegin: node, dataset: {value}}, value));
    }

    get nodes() { return [...this.contentRoot.querySelectorAll("[data-format]")] }

    get #textRender() {
        // if(this.firstElementChild) return;
        // this.textContent = this.nodes.map(n=>n.innerText.trim()).filter(n=>n).join(" ");
    }

    get render() {
        this.#render_clear;
        if(!Object.blank(this.#date)) {
            if(this.lang) this.#date.lang = this.lang;
            this.#strftime.date = this.#date;
            for(const node of this.nodes) this.#render(node);
        }
        this.#textRender;
    }

    get date() { return this.#date; }

    set date(date) {
        this.setClass(!date, "zero");
        if(this.#date === date) return;
        if(typeof date === "number") date = this.now(date);
        if(typeof date === "string") {
            if(isNaN(date)) date = Date.parse(date);
            else date = this.now(parseInt(date));
        }
        if(isNaN(date)) return; //console.warn(date, 'is not a date');
        if(date && !date instanceof Date) throw 'not a date';
        this.#date = date;
        if(!date._zone) this.#date.zone = this.timezone;
        const [time, zone] = this.children;
        if(time) {
            time.value = this.#date.toISOString();
            if(zone) zone.value = this.#date.zone;
        }
        // if(this.timezone) this.#date.zone = this.timezone;

        // this.setClass(localtime.startsWith('1970-01-01T00:00:00'), "zero");

        this.#duration = date.getDifference();
        if(this.#strftime)
            window.requestAnimationFrame(()=>{
                this.render;
            });
    }

    get value() { return this.dateTime }

    set value(value) { this.dateTime = value }

    $datetime(value) {
        this.date = Object.present(value) ? this.now(value) : new Date("Invalid");
        const node = this.firstElementChild;
        if(node?.nodeName !== "INPUT") return
        node.value = value;
    }

    get dateTime() {
        this.getAttribute("datetime");
    }

    set dateTime(value) {
        if(/number|string/.test(typeof value)) value = this.parse(value);
        if(Object.blank(value)) return this.clear;
        this.setAttribute("datetime", value.toZoneISOString(false));
    }

    $format(value) {
        for(const n of this.contentRoot.children) {
            if(n.nodeName !== "SLOT") n.remove();
        }
        this.#strftime = new Date.Strftime(value);
        let i = 0;
        for(let p of this.#strftime.parts) {
            const opts = {beforeend: this.contentRoot, classList: []};
            let part = false;
            switch(typeof p) {
                case "string":
                    part = `_${++i}`
                    SPAN(opts, {part, style: {gridArea: part}}, p); //.replace(/\s/g, "\u00A0"));
                    break;
                case "function":
                    const {places, ...dataset} = p;
                    part = dataset.format.replace(/%/g, '').replace(/\^/g, 'u');
                    SPAN({
                        innerHTML: `<i></i>`.repeat(places),
                        part,
                        style: {gridArea: part},
                        dataset, ...opts
                    }).method = p;
                    break;
            }
        }
        if(this.#date) this.render;
    }

    set format(value) { this.setAttribute('format', value)}

    get format() { return this.getAttribute('format')}
}

QbTime.register;